<template>
  <div class="category-management">
   

    <!-- 分类列表：分页显示 -->
    <a-table
      :dataSource="categories"
      :columns="categoryColumns"
      rowKey="id"
      :pagination="pagination"
      @change="handleTableChange"
      style="margin-top: 20px;"
    >
      <template v-slot:bodyCell="{ column, record, index }">
        <template v-if="column.key === 'sn'">
              {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key == 'name'">
          {{ record.name }}
        </template>
       
      </template>
    </a-table>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted,toRaw,watch } from 'vue';
import http from '@/shared/http.service';
import { Uris } from '@/shared/const';

const categories = ref([]); // 分类列表 
const treeData = ref([]); // 树
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
}); // 分页配置

const labelCol = { style: { width: '90px' } }; // 表单label宽度

// 获取分类列表（包括分页）
const fetchCategories = async (page=1) => {
  try {
      // {params: { pageIndex: page, pageSize: pagination.pageSize },}
       
      http.get(Uris.ClueList, { pageIndex: page, pageSize: pagination.pageSize,orderBy:'stamp',direction:'Desc'  }).subscribe(result=>{
      // 处理后端返回的数据
      const { list, totalCount, totalPageCount, pageIndex, pageSize } = result;
      // 更新分类列表
      categories.value = list;
      pagination.total = totalCount;
      pagination.current = pageIndex;
      pagination.pageSize = pageSize;
      pagination.totalPageCount = totalPageCount;
    }); 
   
  } catch (error) {
    console.error('Error fetching categories', error);
  }
};


// 分页变化处理
const handleTableChange = (pagination) => {
  
  fetchCategories(pagination.current);
};




// 初始化
onMounted(() => {
  fetchCategories(pagination.current);
});



// 表格列配置
const categoryColumns = [
  {
    title: '序号',
    dataIndex: 'sn',
    key: 'sn', 
    width: 80,
    align: 'center',
  },
  {
    title: '联系人',
    width: 150,
    dataIndex: 'linkName',
    key: 'linkName',
    align: 'center',
  },
 {
    title: '联系电话',
    width: 180,
    dataIndex: 'linkPhone',
    key: 'linkPhone',
    align: 'center',
  },
  {
    title: '邮箱',
    width: 180,
    dataIndex: 'email',
    key: 'email',
    align: 'center',
  },
  {
    title: '企业/单位名称',
    width: 200,
    dataIndex: 'companyName',
    key: 'companyName',
    align: 'center',
  },
   {
    title: '担任职位',
    width: 150,
    dataIndex: 'postName',
    key: 'postName',
    align: 'center',
  },
  {
    title: '访问内容',
    width: 300,
    dataIndex: 'title',
    key: 'title',
    align: 'center', 
  },
  {
    title: '来源',
    width: 120,
    dataIndex: 'source',
    key: 'source',
    align: 'center', 
  },
   {
    title: '创建时间',
    width: 180,
    dataIndex: 'stamp',
    key: 'stamp',
    align: 'center', 
  },
    {
    title: '留言',
    dataIndex: 'message',
    key: 'message',
    align: 'center', 
  },
 
];
</script>

<style scoped>
p {
padding-left: 20px;
}

</style>
